import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import logo from '../assets/fuso-logo.svg';
import AdminLangDropdown from './AdminLangDropdown';
import { useAdminI18n } from './i18n';
import './admin.css';

const IconUsers = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
    strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);

const IconChart = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
    strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="3" y1="3" x2="3" y2="21" />
    <line x1="3" y1="21" x2="21" y2="21" />
    <rect x="7" y="11" width="3" height="7" />
    <rect x="12" y="7" width="3" height="11" />
    <rect x="17" y="13" width="3" height="5" />
  </svg>
);

const IconBack = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
    strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M19 12H5" />
    <path d="M12 19l-7-7 7-7" />
  </svg>
);

const IconMenu = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor"
    strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="3" y1="12" x2="21" y2="12" />
    <line x1="3" y1="6" x2="21" y2="6" />
    <line x1="3" y1="18" x2="21" y2="18" />
  </svg>
);

/** Shared chrome: fixed left sidebar nav + top bar (with language dropdown) + content. */
const AdminShell = ({ title, children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const path = location.pathname;
  const [mobileOpen, setMobileOpen] = useState(false);
  const { lang, setLang, t } = useAdminI18n();

  const who =
    localStorage.getItem('userinfo') || localStorage.getItem('userEmail') || 'admin';
  const initial = (who || 'A').trim().charAt(0).toUpperCase();

  const go = (to) => {
    setMobileOpen(false);
    navigate(to);
  };

  const navItems = [
    { to: '/admin', label: t('Users'), icon: <IconUsers />, match: '/admin' },
    { to: '/analytics', label: t('Analytics'), icon: <IconChart />, match: '/analytics' },
  ];

  return (
    <div className="admin-layout">
      {mobileOpen && <div className="admin-scrim" onClick={() => setMobileOpen(false)} />}

      <aside className={`admin-sidebar ${mobileOpen ? 'open' : ''}`}>
        <div className="admin-brand">
          <div className="admin-brand-logo">
            <img src={logo} alt="FUSO" />
          </div>
          <span className="admin-brand-sub">{t('Admin Console')}</span>
        </div>

        <nav className="admin-nav">
          {navItems.map((item) => (
            <button
              key={item.to}
              className={`admin-nav-item ${path.startsWith(item.match) ? 'active' : ''}`}
              onClick={() => go(item.to)}
            >
              {item.icon}
              <span>{item.label}</span>
            </button>
          ))}
        </nav>

        <div className="admin-sidebar-footer">
          <button className="admin-nav-item back" onClick={() => go('/dtc-bot')}>
            <IconBack />
            <span>{t('Back to Chat')}</span>
          </button>
          <div className="admin-user-chip">
            <span className="admin-avatar">{initial}</span>
            <span className="admin-user-name" title={who}>{who}</span>
          </div>
        </div>
      </aside>

      <div className="admin-main">
        <header className="admin-topbar">
          <button className="admin-burger" onClick={() => setMobileOpen(true)} aria-label="Menu">
            <IconMenu />
          </button>
          <h1 className="admin-title">{title}</h1>
          <div className="admin-topbar-spacer" />
          <AdminLangDropdown lang={lang} setLang={setLang} />
        </header>
        <main className="admin-content">{children}</main>
      </div>
    </div>
  );
};

export default AdminShell;
